export default {
  getRoleId (user) {
    if (user !== null && Array.isArray(user.role)) {
      if (user.role[0] !== undefined) {
        return user.role[0].id
      }
    }
    return -1
  },

  // Check user role against an array of RouteRecords
  areRoutesAuthorized (user, records) {
    const roleId = this.getRoleId(user)
    // use is not either admin or super admin
    if (roleId === -1) { return false }

    return records.every(record => {
      if (!Array.isArray(record.meta.authorize)) {
        return false // unexpected type
      }
      if (record.meta.authorize.includes(roleId)) {
        return true
      }
      return false
    })
  }
}
